import { useMonarchRule } from "../MonarchRulesProvider";
import {
  PromoBanner,
  SearchPagePromoTestData,
  UseSearchPagePromo,
} from "./types";
import { getPromoBannerObject } from "./util/getPromoBannerObject";

const CUSTOM_RULE_ID = "searchPagePromo";

const useSearchPagePromo: UseSearchPagePromo = () => {
  const { isLoading, value } = useMonarchRule<{
    data: SearchPagePromoTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    };
  }

  const firstLevelPromoBanner = value?.data?.promoBanner?.firstLevel
    ? getPromoBannerObject(
        value.data.promoBanner as PromoBanner,
        value.data.promoBanner?.firstLevel as PromoBanner,
        value.data.eventing?.firstLevelHtmlId,
        value.data.eventing?.firstLevelLocation,
        value.data.promoBanner?.discountCode,
      )
    : undefined;

  let secondLevelHtmlId = value?.data?.eventing?.secondLevelHtmlId;
  let secondLevelLocation = value?.data?.eventing?.secondLevelLocation;

  const secondLevelPromoBanner = value?.data?.promoBanner?.secondLevel
    ? getPromoBannerObject(
        value.data.promoBanner,
        value.data.promoBanner.secondLevel,
        secondLevelHtmlId,
        secondLevelLocation,
      )
    : undefined;

  const promoBannerCourse = value?.data?.promoBanner?.promoBannerCourse
    ? getPromoBannerObject(
        value.data.promoBanner,
        value.data.promoBanner.promoBannerCourse,
        secondLevelHtmlId,
        secondLevelLocation,
      )
    : undefined;

  const promoBannerProgram = value?.data?.promoBanner?.promoBannerProgram
    ? getPromoBannerObject(
        value.data.promoBanner,
        value.data.promoBanner.promoBannerProgram,
        secondLevelHtmlId,
        secondLevelLocation,
      )
    : undefined;

  const promoBannerEE = value?.data?.promoBanner?.promoBannerEE
    ? getPromoBannerObject(
        value.data.promoBanner,
        value.data.promoBanner.promoBannerEE,
        secondLevelHtmlId,
        secondLevelLocation,
      )
    : undefined;

  const promoBannerDegree = value?.data?.promoBanner?.promoBannerDegree
    ? getPromoBannerObject(
        value.data.promoBanner,
        value.data.promoBanner.promoBannerDegree,
        secondLevelHtmlId,
        secondLevelLocation,
      )
    : undefined;

  return {
    isLoading,
    variant: "test",
    data: {
      firstLevelPromoBanner,
      secondLevelPromoBanner,
      promoBannerCourse,
      promoBannerProgram,
      promoBannerEE,
      promoBannerDegree,
    },
  };
};

export default useSearchPagePromo;
